import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import transEn from './translations/en';
import transDe from './translations/de';
import transHe from './translations/he';
import {configuredDirectionByLanguage} from "./direction";

i18n
  .use(initReactI18next)
  .init({
    interpolation: {escapeValue: false},
    lng:  localStorage.getItem('userLanguage') || process.env.REACT_APP_DEFAULT_LANG,
    fallbackLng: ['en', 'de'],
    resources: {
      he:{
        translation: transHe
      },
      en: {
        translation: transEn
      },
      de: {
        translation: transDe
      }
    },
  });
i18n.on('languageChanged', function (lng) {
  localStorage.setItem('userLanguage', lng);
  configuredDirectionByLanguage(lng);
});
export default i18n;